// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eYFwb","col":"styles_col__1IUWC","actions":"styles_actions__3r5Fg","conflict":"styles_conflict__ViKry"};